import React, { useEffect } from 'react'
import Countdown from 'react-countdown';
import { ICountdown } from '../../planEatApi/PlanEatFacade';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'grid',
        justifyContent: 'flex-start',
        gridTemplateColumns: 'auto auto',
        alignItems: 'center',
        color: '#F39E1E',
        fontSize: 10,
        columnGap: 5,
        marginBottom: 0,
    }
}));

interface Props {
    price:number
    countDownTo: Date
}

export const CountDownClock: React.FC<Props> = ({price,countDownTo}) => {
    // Styling
    const classes = useStyles();

    // State
    const [time, setTime] = React.useState<ICountdown>({
        days:0,
        hours:0,
        minutes:0,
        seconds:0
    });

    useEffect(() => {
        initializeClock()
    }, [countDownTo]);

    function getTimeRemaining() {
        const now = new Date()
        const total = countDownTo.getTime() - now.getTime();
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));
        
        return {
          total,
          days,
          hours,
          minutes,
          seconds
        };
    }

    function initializeClock() {
        function updateClock() {
          const t = getTimeRemaining();
          var tmpCount : ICountdown= {
            days: t.days,
            hours: t.hours,
            minutes: t.minutes,
            seconds: t.seconds
          }
          setTime(tmpCount)

          if (t.total <= 0) {
            clearInterval(timeinterval);
          }
        }

        updateClock();
        const timeinterval = setInterval(updateClock, 1000);
    }

    return (
        <div className={classes.container}>
            <div>
                Closes in:
            </div>
            <Countdown date={countDownTo}/>
        </div>
    );
}